import { Container, Row, Col, Tab } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import colorSharp2 from "../assets/img/color-sharp2.png";
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Projects = () => {

  const projects = [
    {
      title: " Food Delivery Application",
      description: "App Build using ReactJS",
      url:'https://food-app990.netlify.app/',
      imageUrl: "https://cdn.dribbble.com/users/4189231/screenshots/17343305/media/202173138f9504c2eacd16e70698312c.png?compress=1&resize=400x300"   
     },
    {
      title: "Weather Forcasting Application",
      description: "Design & Development",
      url:'https://weather-app888.netlify.app/',
      imageUrl:"https://cdn.dribbble.com/users/1562092/screenshots/14271679/react_weather_app.png"  
    }, 
    {
      title: "Build Authentication System Using Firebase",
      description: "ui/ux",
      url:'https://firebase-auth99.netlify.app/',
      imageUrl:"https://cdn.dribbble.com/users/308682/screenshots/16316303/media/f9b4306971586e66bf77c5a63101e762.png?compress=1&resize=400x300&vertical=top"
    },
  
  ];

  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
           
              <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn": ""}>
                <h2>Projects</h2>
                <Tab.Container id="projects-tabs" defaultActiveKey="first">
                  <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                  <Tab.Pane eventKey="first">
                      <Row>
                        {
                          projects.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row>
                  
                      </Tab.Pane>
                
              </Tab.Content>
              </Tab.Container>
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img alt="jj"className="background-image-right" src={colorSharp2}></img>
    </section>
  )
}
